import classNames from "classnames";
import { FunctionComponent, ReactNode } from "react";
import ButtonSmily from "@Components/atoms/ButtonSmily";
import CheckoutStepHeader from "./CheckoutStepHeader";
import "./style.scss";

interface Props {
  buttonText: string;
  children: ReactNode;
  disabled: boolean;
  displayButton: boolean;
  editable: boolean;
  icon: JSX.Element;
  onEdit: () => void;
  onValidate: () => void;
  title: ReactNode;
  validated: boolean;
}

const CheckoutStep: FunctionComponent<Props> = ({
  buttonText,
  children,
  disabled,
  displayButton,
  editable,
  icon,
  onEdit,
  onValidate,
  title,
  validated,
}) => {
  return (
    <div
      className={classNames("CheckoutStep", {
        "CheckoutStep--validated": validated,
      })}
    >
      <CheckoutStepHeader
        disabled={disabled}
        editable={editable}
        icon={icon}
        onEdit={onEdit}
        title={title}
      />
      <div className="CheckoutStep-content">{children}</div>
      {displayButton && !editable && (
        <ButtonSmily disabled={disabled} onClick={onValidate} size="s" type="primary">
          {buttonText}
        </ButtonSmily>
      )}
    </div>
  );
};

export default CheckoutStep;
